"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Send = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Send = function (_a) {
    var id = _a.id;
    var clipPathId = id ? "Send__clip0__".concat(id) : 'Send__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M23.436.197l.347.346a.667.667 0 01.186.693L15.927 23.56a.666.666 0 01-.626.44h-.213a.68.68 0 01-.612-.387l-4.514-9.582L.388 9.513A.68.68 0 01.002 8.9v-.213a.666.666 0 01.44-.68L22.743.01a.625.625 0 01.227 0 .665.665 0 01.465.187zM13.317 14.83l1.638 3.545 5.22-14.567L5.62 9.033l3.542 1.64a2.661 2.661 0 003.009-.387l2.25-2.08a.665.665 0 01.919 0l.506.507a.667.667 0 010 .92l-2.077 2.252a2.668 2.668 0 00-.453 2.946z", clipRule: "evenodd" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })))));
};
exports.Send = Send;
//# sourceMappingURL=send.js.map